'use strict';
import * as $j_app$002edata$002e$002dDrug$002dDescription from "./app.data.-Drug-Description.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61(evaluator$36) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$61__f_evaluator$16 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$61__f_evaluator$16 = evaluator$36;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$61() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$61 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$61 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$61.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$61__f_evaluator$16.apply__O();
  return ((v instanceof $j_app$002edata$002e$002dDrug$002dDescription.$c_Lapp_data_DrugDescription) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$61 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$61, "app.api.DrugRequestsAcceptedListItem$$anon$61", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$61: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$61 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$61 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$61.js.map
